import React from "react";
import { Icon, Popup } from "semantic-ui-react";
import { TooltipContext } from "./App";
import { useMutation } from "@apollo/client";
import {
  getEventSession,
  getSession,
  getVersion,
  logEventCompleted,
} from "./helper";
import { LOG_EVENT } from "./routes/mutations";
import { EVENT } from "./event";

export const Tooltip = (props: { name: string; message: string }) => {
  const theme = React.useContext(TooltipContext);
  const [logEventMutation] = useMutation(LOG_EVENT, {
    onCompleted: (data) => logEventCompleted(data),
  });

  const onHover = () => {
    const event_metadata = { name: props.name };
    logEventMutation({
      variables: {
        source: 1,
        session: getSession(),
        event_session: getEventSession(),
        event_type_id: EVENT.TOOLTIP_HOVERED,
        event_metadata: JSON.stringify(event_metadata),
        version: getVersion(),
      },
    });
  };

  if (theme === true) {
    return (
      <div onMouseEnter={() => onHover()}>
        <Popup
          content={props.message}
          trigger={<Icon name="info circle" className="tooltip" />}
        ></Popup>
      </div>
    );
  }
  return <></>;
};
